module.exports = __webpack_public_path__ + "img/dcms04.58f9c37b.png";